export const fb = () => {};

export const signUp = () => {
  try {
    if (typeof fbq == 'function') {
      fbq('track', 'CompleteRegistration');
    }
  } catch (e) {}
};
